import { useMemo } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import {
	BankTransactionCategory,
	WalletType,
	walletTypeCurrency,
} from '~/shared';
import { transactionIcons, transactionText } from './Transaction.model';
import {
	StyledContainer,
	StyledDescriptionContainer,
	StyledIconContainer,
	StyledLeftContainer,
	StyledRightContainer,
} from './Transaction.styled';

interface ITransactionProps {
	amount: number;
	description: string;
	category: BankTransactionCategory;
	wallet: WalletType;
}

const Transaction: React.FC<ITransactionProps> = ({
	amount,
	description,
	category,
	wallet,
}: ITransactionProps) => {
	const walletIcon = useWalletIcon(walletTypeCurrency[wallet], true);

	const prefix = useMemo(() => {
		if (amount > 0) {
			if (category === BankTransactionCategory.DEPOSIT) {
				return '';
			}
			return '+';
		}

		return '-';
	}, [category, amount]);

	const categoryIcon = useMemo(() => {
		return transactionIcons[category];
	}, [category]);

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<StyledIconContainer>
					<img src={categoryIcon} />
				</StyledIconContainer>
				<StyledDescriptionContainer>
					<Text
						style={{
							fontSize: '16px',
							fontWeight: 500,
							color: '#FFFFFF',
						}}
					>
						{description}{' '}
					</Text>
					<Text
						style={{
							fontSize: '14px',
							fontWeight: 400,
							color: '#FFFFFF',
							opacity: 0.5,
						}}
					>
						{transactionText[category]}
					</Text>
				</StyledDescriptionContainer>
			</StyledLeftContainer>
			<StyledRightContainer>
				<Text
					style={{
						fontSize: '20px',
						fontWeight: 400,
						color: prefix === '+' ? '#77DE38' : '#FFFFFF',
					}}
				>
					{prefix} {Math.abs(amount).toLocaleString('ru-RU')}
				</Text>
				<CurrencyIcon icon={walletIcon} size={'lg'} />
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Transaction };
